export const adminConstant = {
  //charts
  COMPLAIN_STATUS_COUNT: "/dashboard/complain/count/status",
  COMPLAIN_CATEGORY_COUNT: "/dashboard/complain/count/category",

  // Karyakarta count
  KARYAKARTA_COUNT: "/dashboard/karyakarta/count",
  // INACTIVE_KARYAKARTA_COUNT: "/user/k/o/count/inactive",

  //document count
  DOCUMENTS_COUNT: "/dashboard/doc/count",
  RECENT_DOCUMENT_COUNT: "/dashboard/doc/count/recent",

  //keosks count
  KEOSKS_COUNT: "/dashboard/kiosk/count",
  // KEOSKS_COUNT_NOT_WORKING: "/office/kiosk/notworking/count",

  BIRTHDAY_COUNT: "/todays-event/count",
};
